import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/light/pencil-ruler.svg'
import BaseIcon from '../../BaseIcon'

const PencilRuler = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 512 512" />
}

PencilRuler.propTypes = {
	className: PropTypes.string,
}

export default PencilRuler
